export const tableColumn = [
  {
    text:'ID',
    value:'id'
  },
  {
    text:'使用链接',
    value:'usePath'
  },
  {
    text:'回调地址',
    value:'callBackUrl'
  },
  {
    text:'优惠券名称',
    value:'name'
  },
  {
    text:'优惠券面额',
    value:'discountAmountBd'
  },
  {
    text:'券类型',
    value:'typeStr'
  },
  {
    text:'有效期',
    value:'useTimeRange'
  },
  {
    text:'领取人数',
    value:'getCount'
  },
  {
    text:'已使用',
    value:'useCount'
  },
  {
    text:'已过期',
    value:'expireCount'
  },
  {
    text:'启用状态',
    value:'status'
  },
  {
    text:'创建时间',
    value:'createTime'
  },
]
export const tableColumnUseDy = [
  {
    text:'用券用户',
    value:'fansId'
  },
  {
    text:'领券时间',
    value:'receiveTimeStr'
  },
  {
    text:'优惠券名称',
    value:'couponName'
  },
  {
    text:'优惠券面值',
    value:'discountAmountBd'
  },
  {
    text:'优惠券状态',
    value:'couponStatus'
  },
  {
    text:'用券订单',
    value:'orderId'
  },
  {
    text:'市场价',
    value:'initPriceBd'
  },
  {
    text:'券后支付价',
    value:'couponPayPriceBd'
  },
  {
    text:'应付价格',
    value:'originalPriceBd'
  },
  {
    text:'用券时间',
    value:'useTimeStr'
  },
]


// WEBPACK FOOTER //
// ./src/views/pc/miniProgram/couponDy/enum.js